/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts needed this race to trigger change`)
};

const es_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts necesarios esta carrera para activar cambio`)
};

const de_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = dieses Rennen benötigte Pkt. für Änderung`)
};

const nl_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = benodigde pnt. deze race voor prijswijziging`)
};

const fr_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts nécessaires cette course pour déclencher un changement`)
};

const it_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts necessari questa gara per attivare la variazione`)
};

const pt_br2_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts necessários esta corrida para acionar mudança`)
};

const pt_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = pts necessários esta corrida para acionar alteração`)
};

const ja_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = 今レースの変動トリガーに必要なポイント`)
};

const zh_f1_budget_legend_rpts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rPts = 本场触发变动所需积分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_legend_rpts = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_legend_rpts(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_legend_rpts", locale)
	if (locale === "en") return en_f1_budget_legend_rpts(inputs)
	if (locale === "es") return es_f1_budget_legend_rpts(inputs)
	if (locale === "de") return de_f1_budget_legend_rpts(inputs)
	if (locale === "nl") return nl_f1_budget_legend_rpts(inputs)
	if (locale === "fr") return fr_f1_budget_legend_rpts(inputs)
	if (locale === "it") return it_f1_budget_legend_rpts(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_legend_rpts(inputs)
	if (locale === "pt") return pt_f1_budget_legend_rpts(inputs)
	if (locale === "ja") return ja_f1_budget_legend_rpts(inputs)
	return zh_f1_budget_legend_rpts(inputs)
};